<template>
  <Modal
    v-model="state"
    :title="title"
    :mask-closable="false"
    width="920"
    class-name="vertical-center-modal"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="loading" style="z-index: 999"></Spin>

    <div class="m-header">
      <span>执行范围：</span>
      <RadioGroup v-model="execFlag" type="button">
        <Radio label="account" border
          >定向账号 <ins style="color: #ff9900" v-show="lockLen">({{ lockLen }})</ins></Radio
        >
        <Radio label="include" border
          >定向计划 <ins style="color: #ff9900" v-show="planLen">({{ planLen }})</ins></Radio
        >
        <Radio label="exclude" border
          >排除计划 <ins style="color: #ff9900" v-show="excludePlanLen">({{ excludePlanLen }})</ins></Radio
        >
      </RadioGroup>
    </div>

    <!-- 定向账号 -->
    <select-account
      v-show="execFlag === 'account'"
      ref="account"
      v-model="mult_account"
      :data="data"
      :title="['账号']"
      search
      @on-select="selectAll"
      @on-delete="delTag"
      @on-clear="clearTag"
    />

    <!-- 定向广告 -->
    <select-plan
      v-show="execFlag === 'include'"
      ref="include"
      :data="includeData"
      :preload="preload"
      :loading="loading"
      :media="media"
      :plan-ids="planIds"
      :sub-media="subMedia"
      @on-select="selectAll"
    />

    <!-- 排除广告 -->
    <select-plan
      v-show="execFlag === 'exclude'"
      ref="exclude"
      :data="excludeData"
      :preload="preload"
      :loading="loading"
      :sub-media="subMedia"
      :media="media"
      :plan-ids="excludePlanIds"
      @on-select="selectAll"
    />

    <!-- footer -->
    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="asyning" @click="$emit('on-change')">
          <span v-if="asyning">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { getIdOfData, findCheck, getNameOfData, clearTagOfData, trim, isEmpty } from '@/common/js/utils'
import SelectPlan from './plan/select-plan'
import SelectAccount from './account/select-account'

export default {
  components: { SelectAccount, SelectPlan },
  props: {
    subMedia: {
      type: Number
    },
    value: {
      type: Boolean
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    includeData: {
      type: Array,
      default() {
        return []
      }
    },
    excludeData: {
      type: Array,
      default() {
        return []
      }
    },
    media: {
      type: [Number, String]
    },
    planLen: {
      type: Number,
      default: 0
    },
    lockLen: {
      type: Number,
      default: 0
    },
    excludePlanLen: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    asyning: {
      type: Boolean,
      default: false
    },
    preload: {
      type: Boolean,
      default: false
    },
    planIds: {
      type: Array,
      required: true
    },
    excludePlanIds: {
      type: Array,
      required: true
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    title() {
      let subTitle = ''
      if (this.planLen || this.excludePlanLen || this.lockLen) {
        subTitle = `  （共锁定账号${this.lockLen}个，定向计划${this.planLen}个，排除计划${this.excludePlanLen}个）`
      }
      return `选择账号计划 ${subTitle}`
    },
    mult_account() {
      return findCheck(this.data)
    }
  },
  methods: {
    bindGetData(val) {
      // 编辑状态显示时更新数据
      this.$refs.account.updateResource(false) // 选择账号框
      this.$refs.include.bindGetData(val) // 定向账号框
      this.$refs.exclude.bindGetData(val) // 排除账号框
    },
    // 全选
    selectAll({ list, check = true, current = '', keyword = '' }) {
      console.log(keyword)
      let data
      // 无限递归
      const setAllChecked = (data, check) => {
        data = data.filter((ret) => isEmpty(keyword) || ret.name.toLowerCase().includes(trim(keyword).toLowerCase()))
        data.forEach((ret) => {
          if (ret.children && ret.children.length) setAllChecked(ret.children, check)
          this.$set(ret, 'check', check)
        })
      }
      if (current) {
        const item = getIdOfData(list, current)
        data = item.children
      } else data = list
      setAllChecked(data, check)
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    }
  },
  data() {
    return {
      execFlag: 'account'
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.c-select-item {
  .c-selecter-content {
    height: 368px !important;
  }
}

::v-deep.item-border {
  .c-selecter-content {
    height: 416px !important;
  }
}

::v-deep.ivu-modal {
  position: relative;
  z-index: 99;
}

.m-header {
  margin-bottom: 16px;
}

::v-deep .ivu-tag {
  .ivu-icon-ios-close {
    top: 3px;
    float: right;
  }
}
</style>
